import {
  amber, grey, green, indigo, red, common,
} from '@mui/material/colors';

const colors = {
  white: common.white,
  background: grey[50],
  primary: indigo[900],
  secondary: green[500],
  positive: green[500],
  medium: amber[700],
  negative: red[500],
  neutral: grey[500],
  geometry: '#3bb2d0',
  wt_green: '#00a0c6',
};

export default {
  background: {
    default: colors.background,
  },
  primary: {
    // main: colors.primary,
    main: colors.wt_green,
  },
  // secondary: {
  //   main: colors.secondary,
  //   contrastText: colors.white,
  //   sidebar: colors.white,
  // },
  secondary: {
    main: colors.wt_green,
    contrastText: colors.white,
    sidebar: colors.white,
  },
  tertiary: {
    main: colors.wt_green,
    contrastText: colors.white,
    sidebar: colors.white,
  },
  colors,
};
